module.exports = __webpack_public_path__ + "static/media/running-free.9c9a5266.jpg";